import { useMemo } from "react";
import { useList } from "@/lib/api/queries";

interface Person {
  id: string;
  username: string;
  full_name: string;
}

/**
 * Xodim ismlari BITTA so'rovda — identity `ids` bilan. Sahifada
 * o'nlab qator bo'lishi mumkin va har biriga alohida so'rov
 * yuborish ro'yxatni sekinlashtirardi.
 */
export function usePeople(ids: Array<string | undefined>) {
  const key = [...new Set(ids.filter((id): id is string => Boolean(id)))].sort().join(",");
  const users = useList<Person>("identity", "/api/v1/users", { ids: key, limit: 500 }, { enabled: key !== "" });
  return useMemo(
    () => new Map((users.data?.items ?? []).map((user) => [user.id, user.full_name || user.username] as const)),
    [users.data],
  );
}
